import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//创建路由对象
const router=new VueRouter({
    routes:[
        {
            path: "/",
            redirect: "/webinfo",
        },
        {
            path: "/webinfo",
            component:()=>import("../views/jianliWeb.vue")
        },
        {
            path: "/webshare",
            component:()=>import("../views/shareWeb.vue")
        },
        {
            path: "/unityinfo",
            component:()=>import("../views/jianliUnity.vue")
        },
        {
            path: "/unityshare",
            component:()=>import("../views/shareUnity.vue")
        },
        {
            path: "/unitygame",
            component:()=>import("../views/downloadUnity.vue")
        },
        {
            path:"/other1",
            component:()=>import("../views/other1.vue")
        },
        {
            path:"/other2",
            component:()=>import("../views/other2.vue")
        }
    ]
})

//暴露
export default router